// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"314":"e50007be","422":"6e7c02e1","679":"75ec48e8","845":"79dc2fc6","869":"deabd1d4"}[chunkId] + ".chunk.js";
};